import { render, staticRenderFns } from "./LoanStatusAlert.vue?vue&type=template&id=a1d7e44c&scoped=true"
import script from "./LoanStatusAlert.vue?vue&type=script&lang=js"
export * from "./LoanStatusAlert.vue?vue&type=script&lang=js"
import style0 from "./LoanStatusAlert.vue?vue&type=style&index=0&id=a1d7e44c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d7e44c",
  null
  
)

export default component.exports